import type React from 'react'
import { Link } from 'react-router-dom'

export interface TitleSectionProps {
  readonly orgName: string | null
  readonly newPlanHref: string
}

function PlusIcon(): React.ReactElement {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  )
}

export function TitleSection({ orgName, newPlanHref }: TitleSectionProps): React.ReactElement {
  return (
    <div className="flex flex-wrap items-end justify-between gap-6 pb-8 pt-10">
      <div className="max-w-2xl">
        {orgName && (
          <div
            className="mb-3 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary"
            data-testid="title-eyebrow"
          >
            <span aria-hidden="true">✦</span>
            <span>Workspace · {orgName}</span>
          </div>
        )}
        <h1 className="font-serif text-4xl leading-[1.05] tracking-tight text-foreground sm:text-5xl">
          Your research <em className="font-serif italic text-primary">plans.</em>
        </h1>
      </div>

      <div className="flex items-center gap-2">
        <button
          type="button"
          className="inline-flex items-center gap-2 rounded-full border border-border bg-surface-elevated px-4 py-2 text-sm font-medium text-foreground hover:bg-muted"
          data-testid="customize-button"
        >
          Customize
        </button>
        <Link
          to={newPlanHref}
          className="inline-flex items-center gap-1.5 rounded-full bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow-xs hover:opacity-90"
          data-testid="new-plan-button"
        >
          <PlusIcon />
          New plan
        </Link>
      </div>
    </div>
  )
}
